/**
 * @deprecated これらの関数は @monorepo/common から直接インポートしてください
 * 例: import { formatDateCommon, formatDateAboutJa, formatCurrency } from '@monorepo/common'
 */
export { formatCurrency, formatDateAboutJa, formatDateCommon } from '@monorepo/common';
